export const reassignAndTerminateTerminateRequest_actionType = {
    REASSIGN_AND_TERMINATE_TERMINATE_REQUEST: "REASSIGN_AND_TERMINATE_TERMINATE_REQUEST",
    REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_SUCCESS: "REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_SUCCESS",
    REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_ERROR: "REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_ERROR",
    REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_RESET: "REASSIGN_AND_TERMINATE_TERMINATE_REQUEST_RESET"
};